import ArticleLayout from '@/components/feature/ArticleLayout';
import { articoloGuidaShopping } from '@/mocks/articles';

export default function GuidaShoppingPage() {
  return <ArticleLayout article={articoloGuidaShopping} />;
}